/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import Nav from '../nav';
import { StyledSubNav } from './style';

const routerWithoutSubNav = ['portfolio/position', 'portfolio/analysis', 'details/'];

export default function SubNav({ userInfo, subNavs, subNavKey, mainKey }: any) {
  const { isAnonymous, isPersonal } = userInfo;
  const isInBlackList = mainKey && routerWithoutSubNav.some((r) => mainKey.startsWith(r));
  const getNavs = () => {
    // 游客过滤数据报表 投研框架
    if ((isAnonymous || isPersonal) && subNavs) {
      return subNavs.filter((n: any) => !['数据报表', '投研框架', '关系图谱'].includes(n.text));
    }
    return subNavs;
  };
  if (!isInBlackList && subNavs && subNavs.length > 1 && subNavKey)
    return (
      <StyledSubNav>
        <Nav navs={getNavs()} activeKey={subNavKey} isSub />
      </StyledSubNav>
    );
  return null;
}
